import Locals from '../providers/Locals';

const API_BASE_URL = Locals.config().base_api_url;

// Same resolution as the scan photos (shared-ui dmScansService absolutify): signed paths are
// relative to the API host. Anything not http(s) or root-relative is dropped so it never hits an href.
export function resolveSignedUrl(url: unknown): string | null {
    if (typeof url !== 'string' || url === '') return null;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith('/') && !url.startsWith('//')) return `${API_BASE_URL}${url}`;
    return null;
}
